import {
    FETCH_CATEGORIES_SUCCESS_ACTION,
    CATEGORY_ADD_ACTION,
    CATEGORY_EDIT_ACTION,
    CATEGORY_DELETE_ACTION
} from '../actions/marketPlaceCategoryActions';

export const categoriesReducer = (state = [], action) => {
    switch(action.type){
        case FETCH_CATEGORIES_SUCCESS_ACTION:
            const newCategories = action.payload;
            const oldCategories = Object.values({...state}).filter(s => !newCategories.some(newS => newS.id === s.id));
            const newCategoryState = oldCategories.concat(newCategories);
            return newCategoryState;
        case CATEGORY_ADD_ACTION:
            const clonedState = [...state];
            clonedState.push(action.payload);
            return clonedState;
        case CATEGORY_EDIT_ACTION:
            const newCategory = action.payload;
            const categoriesCopy = Object.values({...state}).filter(s => !(newCategory.id === s.id));
            categoriesCopy.push(newCategory);
            return categoriesCopy;
        case CATEGORY_DELETE_ACTION:
            return state.filter(element => element.id !== action.payload);
        default:
            return state;
    }
};
